import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

import { toRef, computed } from 'vue';
import { ElSelect, ElOption } from 'element-plus';
import { SelectOption } from '@/types';

interface Props {
  value: string | number,
  options: SelectOption[],
  disabled?: boolean,
  error?: any,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiSelect',
  props: {
    value: { default: '' },
    options: {},
    disabled: { type: Boolean, default: false },
    error: { default: null }
  },
  emits: ["change", "focus", "blur"],
  setup(__props: any) {

const props = __props;



const modelValue = toRef(props, 'value');

const customClass = computed(() => ({
  'is-error': props.error,
}));


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElSelect), {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    placeholder: "",
    disabled: _ctx.disabled,
    class: _normalizeClass(["main-select", customClass.value]),
    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('change', $event))),
    onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('focus', $event))),
    onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('blur', $event)))
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
        return (_openBlock(), _createBlock(_unref(ElOption), {
          key: item.value,
          label: item.label,
          value: item.value
        }, null, 8, ["label", "value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue", "disabled", "class"]))
}
}

})